import { gql, useQuery } from '@apollo/client';
import { useMemo } from 'react';
const FETCH_ASSOCIATION_DEFINITIONS_BETWEEN_OBJECT_TYPES = ("__gql__", "{\"kind\":\"Document\",\"definitions\":[{\"kind\":\"OperationDefinition\",\"operation\":\"query\",\"name\":{\"kind\":\"Name\",\"value\":\"AssociationDefinitionsBetweenObjectTypesQuery\"},\"variableDefinitions\":[{\"kind\":\"VariableDefinition\",\"variable\":{\"kind\":\"Variable\",\"name\":{\"kind\":\"Name\",\"value\":\"toObjectTypeId\"}},\"type\":{\"kind\":\"NonNullType\",\"type\":{\"kind\":\"NamedType\",\"name\":{\"kind\":\"Name\",\"value\":\"String\"}}}},{\"kind\":\"VariableDefinition\",\"variable\":{\"kind\":\"Variable\",\"name\":{\"kind\":\"Name\",\"value\":\"fromObjectTypeId\"}},\"type\":{\"kind\":\"NonNullType\",\"type\":{\"kind\":\"NamedType\",\"name\":{\"kind\":\"Name\",\"value\":\"String\"}}}}],\"selectionSet\":{\"kind\":\"SelectionSet\",\"selections\":[{\"kind\":\"Field\",\"name\":{\"kind\":\"Name\",\"value\":\"allAssociationTypesBetweenObjectTypes\"},\"arguments\":[{\"kind\":\"Argument\",\"name\":{\"kind\":\"Name\",\"value\":\"fromObjectType\"},\"value\":{\"kind\":\"Variable\",\"name\":{\"kind\":\"Name\",\"value\":\"fromObjectTypeId\"}}},{\"kind\":\"Argument\",\"name\":{\"kind\":\"Name\",\"value\":\"toObjectType\"},\"value\":{\"kind\":\"Variable\",\"name\":{\"kind\":\"Name\",\"value\":\"toObjectTypeId\"}}}],\"selectionSet\":{\"kind\":\"SelectionSet\",\"selections\":[{\"kind\":\"Field\",\"name\":{\"kind\":\"Name\",\"value\":\"associationCategory\"}},{\"kind\":\"Field\",\"name\":{\"kind\":\"Name\",\"value\":\"associationTypeId\"}},{\"kind\":\"Field\",\"name\":{\"kind\":\"Name\",\"value\":\"hasAllAssociatedObjects\"}},{\"kind\":\"Field\",\"name\":{\"kind\":\"Name\",\"value\":\"fromObjectTypeId\"}},{\"kind\":\"Field\",\"name\":{\"kind\":\"Name\",\"value\":\"inverseAssociationTypeId\"}},{\"kind\":\"Field\",\"name\":{\"kind\":\"Name\",\"value\":\"label\"}},{\"kind\":\"Field\",\"name\":{\"kind\":\"Name\",\"value\":\"toObjectTypeId\"}},{\"kind\":\"Field\",\"name\":{\"kind\":\"Name\",\"value\":\"isPrimary\"}},{\"kind\":\"Field\",\"name\":{\"kind\":\"Name\",\"value\":\"isInversePrimary\"}},{\"kind\":\"Field\",\"name\":{\"kind\":\"Name\",\"value\":\"toObjectTypeDefinition\"},\"selectionSet\":{\"kind\":\"SelectionSet\",\"selections\":[{\"kind\":\"Field\",\"name\":{\"kind\":\"Name\",\"value\":\"singularForm\"}}]}}]}}]}}]}", {
  id: null,
  kind: "Document",
  definitions: [{
    kind: "OperationDefinition",
    operation: "query",
    name: {
      kind: "Name",
      value: "AssociationDefinitionsBetweenObjectTypesQuery"
    },
    variableDefinitions: [{
      kind: "VariableDefinition",
      variable: {
        kind: "Variable",
        name: {
          kind: "Name",
          value: "toObjectTypeId"
        }
      },
      type: {
        kind: "NonNullType",
        type: {
          kind: "NamedType",
          name: {
            kind: "Name",
            value: "String"
          }
        }
      }
    }, {
      kind: "VariableDefinition",
      variable: {
        kind: "Variable",
        name: {
          kind: "Name",
          value: "fromObjectTypeId"
        }
      },
      type: {
        kind: "NonNullType",
        type: {
          kind: "NamedType",
          name: {
            kind: "Name",
            value: "String"
          }
        }
      }
    }],
    selectionSet: {
      kind: "SelectionSet",
      selections: [{
        kind: "Field",
        name: {
          kind: "Name",
          value: "allAssociationTypesBetweenObjectTypes"
        },
        arguments: [{
          kind: "Argument",
          name: {
            kind: "Name",
            value: "fromObjectType"
          },
          value: {
            kind: "Variable",
            name: {
              kind: "Name",
              value: "fromObjectTypeId"
            }
          }
        }, {
          kind: "Argument",
          name: {
            kind: "Name",
            value: "toObjectType"
          },
          value: {
            kind: "Variable",
            name: {
              kind: "Name",
              value: "toObjectTypeId"
            }
          }
        }],
        selectionSet: {
          kind: "SelectionSet",
          selections: [{
            kind: "Field",
            name: {
              kind: "Name",
              value: "associationCategory"
            }
          }, {
            kind: "Field",
            name: {
              kind: "Name",
              value: "associationTypeId"
            }
          }, {
            kind: "Field",
            name: {
              kind: "Name",
              value: "hasAllAssociatedObjects"
            }
          }, {
            kind: "Field",
            name: {
              kind: "Name",
              value: "fromObjectTypeId"
            }
          }, {
            kind: "Field",
            name: {
              kind: "Name",
              value: "inverseAssociationTypeId"
            }
          }, {
            kind: "Field",
            name: {
              kind: "Name",
              value: "label"
            }
          }, {
            kind: "Field",
            name: {
              kind: "Name",
              value: "toObjectTypeId"
            }
          }, {
            kind: "Field",
            name: {
              kind: "Name",
              value: "isPrimary"
            }
          }, {
            kind: "Field",
            name: {
              kind: "Name",
              value: "isInversePrimary"
            }
          }, {
            kind: "Field",
            name: {
              kind: "Name",
              value: "toObjectTypeDefinition"
            },
            selectionSet: {
              kind: "SelectionSet",
              selections: [{
                kind: "Field",
                name: {
                  kind: "Name",
                  value: "singularForm"
                }
              }]
            }
          }]
        }
      }]
    }
  }]
});
const getUnlabeledAssociationDefinition = associationDefinitions => {
  const unlabeledAssociationDefinition = associationDefinitions.length === 1 ? associationDefinitions[0] : associationDefinitions.find(({
    label
  }) => !label);
  return unlabeledAssociationDefinition;
};
const useQueryUnlabeledAssociationDefinition = ({
  fromObjectTypeId,
  toObjectTypeId
}, {
  skip
} = {}) => {
  const {
    data,
    loading,
    error
  } = useQuery(FETCH_ASSOCIATION_DEFINITIONS_BETWEEN_OBJECT_TYPES, {
    variables: {
      fromObjectTypeId,
      toObjectTypeId
    },
    skip
  });
  const unlabeledAssociationDefinition = useMemo(() => {
    const associationDefinitions = data && data.allAssociationTypesBetweenObjectTypes || [];
    return getUnlabeledAssociationDefinition(associationDefinitions);
  }, [data]);

  // transform the inverseAssociationTypeId and associationCategory label to be compatible with useQueryAssociationDefinition response
  const transformedUnlabeledAssociationDefinition = unlabeledAssociationDefinition ? Object.assign({}, unlabeledAssociationDefinition, {
    inverseId: unlabeledAssociationDefinition.inverseAssociationTypeId,
    category: unlabeledAssociationDefinition.associationCategory
  }) : null;
  return {
    unlabeledAssociationDefinition: transformedUnlabeledAssociationDefinition,
    loading,
    error
  };
};
export default useQueryUnlabeledAssociationDefinition;